import React, { useState } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

function Galeri() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const images = [
    `${process.env.PUBLIC_URL}/galeri1.jpeg`,
    `${process.env.PUBLIC_URL}/galeri2.jpeg`,
    `${process.env.PUBLIC_URL}/galeri3.jpeg`,
    `${process.env.PUBLIC_URL}/galeri4.jpeg`,
    `${process.env.PUBLIC_URL}/galeri5.jpeg`,
    `${process.env.PUBLIC_URL}/galeri6.jpeg`,
    `${process.env.PUBLIC_URL}/galeri7.jpeg`,
    `${process.env.PUBLIC_URL}/galeri8.jpeg`,
    `${process.env.PUBLIC_URL}/galeri9.jpeg`,
  ];

  const openImage = (index) => {
    setSelectedImageIndex(index);
  };

  const closeImage = () => {
    setSelectedImageIndex(null);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((selectedImageIndex + 1) % images.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((selectedImageIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="w-full min-h-[calc(100vh-64px)] bg-white">
      {/* Başlık */}
      <div className="bg-gradient-to-r from-slate-50 to-slate-100 py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">GALERİ</h1>
          <div className="w-20 h-1 bg-primary mx-auto"></div>
          <p className="text-gray-600 mt-4">Öztürk Kereste'nin projelerinden görüntüler</p>
        </div>
      </div>

      {/* Galeri */}
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer h-64 md:h-72"
              onClick={() => openImage(index)}
            >
              <img
                src={image}
                alt={`Galeri ${index + 1}`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4.5-4.5 3 3 4.5-4.5L16 15z" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImageIndex !== null && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex justify-center items-center z-50 p-4"
          onClick={closeImage}
        >
          <div className="relative max-w-4xl w-full">
            {/* Kapat butonu */}
            <button
              onClick={closeImage}
              className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Resim */}
            <img
              src={images[selectedImageIndex]}
              alt="Seçili"
              className="w-full h-auto object-contain max-h-[80vh]"
              onClick={(e) => e.stopPropagation()}
            />

            {/* Önceki butonu */}
            <button
              onClick={prevImage}
              className="absolute top-1/2 -left-16 md:left-4 transform -translate-y-1/2 bg-white hover:bg-gray-100 rounded-full p-3 transition-all duration-300 text-gray-900"
            >
              <FaArrowLeft size={20} />
            </button>

            {/* Sonraki butonu */}
            <button
              onClick={nextImage}
              className="absolute top-1/2 -right-16 md:right-4 transform -translate-y-1/2 bg-white hover:bg-gray-100 rounded-full p-3 transition-all duration-300 text-gray-900"
            >
              <FaArrowRight size={20} />
            </button>

            {/* Sayaç */}
            <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 text-white text-sm">
              {selectedImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Galeri;